import http from '@/fetch/http'
import * as types  from '@/vuex/types'
import Vue from 'vue'

const state = {
  own: true,//是否是班主任？
  students: [],//学生列表
  cStudent: {
    id: "",
    no: "",
    name: "",
    schoolId: "",
    createBy: "",
    classId: "",
    stuClassId: "",
    starNum :0,
    loginCount:'0',
    checkRecord: {
      late: 0,
      leave: 0,
      truant: 0,
      vacation: 0,
    }
  },
  cClazz: {classId: '0', isMaster: '0'},
  groupList: [],
  //题库列表
  studentListPage: [],
  studentListPageNo: 1,
  studentListPageSize: types.SCROLL_LOADING.BANK_LIST_PAGE_SIZE
}

const actions = {
  /**
   * 查询学生
   * @param commit
   * @param name
   */
  selectStudentList({commit}, param){
    let params = {
      classId: param.classId,
      pageNo: state.studentListPageNo,
      pageSize: state.studentListPageSize,
      name:param.name,
    }
    http.GetStudentsByClassIdByFenYe(params).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit("SET_STUDENT_LIST_PAGE", res.data);
      }
    })
  },
  /**
   * 查询学生
   * @param commit
   * @param name
   */
  selectStudents({commit}, param){
    let params = {
      classId: param.classId,
      pageNo: state.studentListPageNo,
      pageSize: state.studentListPageSize,
      name:param.name,
    }
    return http.GetStudentsByClassIdByFenYe(params).then(res => {
      if (res.msgCode == types.STATUS_OK) {
        commit(types.SET_STUDENTS, res.data);
      }
    })
  },
  // 改变当前页数
  setStudentListPageNo({commit}, params){
    commit("SET_STUDENT_LIST_PAGE_NO", params);
  },
  // 改变当前每页条数
  setStudentListPageSize({commit}, params){
    commit("SET_STUDENT_LIST_PAGE_SIZE", params);
  },
  setStudentListPage(params) {
    commit("SET_STUDENT_LIST_PAGE", params);
  },
  setStudentsByClazzId({commit}, param){
    let params = {
      classId : param.classId,
      name : param.name
    }
    http.GetStudentsByClassId(params)
    .then(res => {
      commit(types.SET_STUDENTS, res.data);
    })
  },
  setCStudent({commit}, student){
    commit(types.SET_CSTUDENT, student);
  },
  setCClazz({commit}, param){
    http.GetClassInfoById(param)
      .then(res => {
        commit('SET_CCLAZZ', res.data);
      })
  },
  setGroupList({commit}, groupList){
    commit('GROUP_LIST', groupList);
  }
}

const getters = {
  // getStudents: state => state.students,
  // getClassId: state => state.classId,
  // getCClazz:state =>{
  //   return JSON.parse(sessionStorage.getItem('cClazz'))||{}
  // }
}


const mutations = {
  [types.SET_STUDENTS](state, res) {
    if(res && res.list){
      let students = state.students.concat(res.list);
      Vue.set(state, 'students', students);
    }
  },
  [types.SET_CSTUDENT](state, student) {
    Vue.set(state, 'cStudent', student);
  },
  ['SET_CCLAZZ'](state, clazz){
    Vue.set(state, "cClazz", clazz);
  },
  ['GROUP_LIST'](state, groupList){
    Vue.set(state, "groupList", groupList);
  },
  ['SET_STUDENT_LIST_PAGE'](state, page) {
    Vue.set(state, 'studentListPage', page);
  },
  ['SET_STUDENT_LIST_PAGE_NO'](state, params) {
    Vue.set(state, 'studentListPageNo', params);
  },
  ['SET_STUDENT_LIST_PAGE_SIZE'](state, params) {
    Vue.set(state, 'studentListPageSize', params);
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/editstudent.js